import React from 'react';
import { useEffect, useRef } from 'react'
import TextField from '@mui/material/TextField';

import "./multilinetext.css"

export const MultilineText = ({label, text, disabled, rows, textcolor, backcolor, onChange}) => {


  const textAreaRef = useRef(null);

  useEffect(() => {
    
    if (textAreaRef.current) {
      textAreaRef.current.style.height = 'auto';
      textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`;
    }
    
  }, [text, textAreaRef]);
  
  return (
    <TextField
        id="outlined-multiline-flexible"
        label={label}
       
        multiline
        maxRows={rows}
        size="small"
        fullWidth
        sx={{ fontStyle:'italic'}}
        InputProps={{
                      style: { color: textcolor, fontSize: '14px', backgroundColor:backcolor}
                    }}
        InputLabelProps={{
                      style: { fontSize: '16px', color:'white' }
                    }}   
        value = {text}
        onChange={onChange}
      />  
  );

 
};

MultilineText.defaultProps = {
  disabled: false,
  backcolor:  'rgb(59, 75, 93)',
  textcolor:'white',
  rows: 4,
}
